/* =============================================================================
   GRACIAS.JS — pinta el pedido en /pages/gracias (sections/gracias-main.liquid).
   Fuente de datos: 'pz_last_order', guardado por assets/pro360-boot.js
   (módulo easysellThankyou) vía window.es_hook_before_redirect de EasySell.
   Sin datos → la página queda en versión genérica (sin resumen).
   Demo: ?demo=1 | ?demo=lima | ?demo=provincia (y siempre en el editor de temas).
   ============================================================================= */
(function () {
  'use strict';

  var KEY = 'pz_last_order';
  var MAX_AGE_MS = 6 * 60 * 60 * 1000;   // fallback localStorage: 6 h
  var LIMA_CODES = ['PE-LMA', 'PE-CAL'];  // Lima Metropolitana + Callao

  var DEMO = {
    number: '1049', first_name: 'María', currency: 'PEN',
    subtotal: 149, discount: 49, total: 149, shipping_title: 'Envío gratis', shipping_price: 0,
    province_code: 'PE-LMA', province: 'Lima (provincia)', city: 'Barranco', status_url: '',
    items: [{ title: 'Multi Collagen Peptides Complex', variant_title: '', quantity: 2, price: 99, handle: 'multi-collagen-peptides-complex' }]
  };

  function money(n) {
    return 'S/ ' + Number(n || 0).toFixed(2);  // espacio duro: "S/" no se separa del monto
  }

  function readStored() {
    var raw = null;
    try { raw = sessionStorage.getItem(KEY); } catch (e) {}
    if (!raw) {
      try {
        raw = localStorage.getItem(KEY);
        var parsed = raw && JSON.parse(raw);
        if (!parsed || Date.now() - (parsed.saved_at || 0) > MAX_AGE_MS) raw = null;
      } catch (e) { raw = null; }
    }
    try { return raw ? JSON.parse(raw) : null; } catch (e) { return null; }
  }

  function getData(root, params) {
    var demo = params.get('demo') || (root.hasAttribute('data-demo') ? '1' : '');
    if (demo) {
      var d = JSON.parse(JSON.stringify(DEMO));
      if (demo === 'provincia') { d.province_code = 'PE-ARE'; d.province = 'Arequipa'; d.city = 'Arequipa'; }
      return d;
    }
    var data = readStored();
    var urlNumber = params.get('pedido');
    // Pedido viejo de otra compra → no mostrar un resumen que no corresponde.
    if (data && urlNumber && data.number && data.number !== urlNumber) data = null;
    if (!data && urlNumber) data = { number: urlNumber, items: [] };
    return data;
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function firstWord(name) {
    var w = String(name || '').trim().split(/\s+/)[0] || '';
    if (w.length < 2) return '';
    return w.charAt(0).toUpperCase() + w.slice(1).toLowerCase();
  }

  // ---- Saludo ---------------------------------------------------------------
  function paintHero(root, data) {
    var name = firstWord(data.first_name);
    var nameEl = root.querySelector('[data-gr-name]');
    if (name && nameEl) { nameEl.textContent = ', ' + name; nameEl.hidden = false; }
    if (data.number) {
      root.querySelector('[data-gr-order]').textContent = '#' + data.number;
      root.querySelector('[data-gr-order-wrap]').hidden = false;
    }
  }

  // ---- Resumen --------------------------------------------------------------
  function loadImage(handle, media) {
    if (!handle || !window.fetch) return;
    fetch('/products/' + encodeURIComponent(handle) + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        var src = p && (p.featured_image || (p.images && p.images[0]));
        if (!src) return;
        var img = new Image();
        img.alt = p.title || '';
        img.loading = 'lazy';
        img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=160';
        media.insertBefore(img, media.firstChild);
      })
      .catch(function () {});
  }

  function paintSummary(root, data) {
    if (!data.items || !data.items.length) return;
    var list = root.querySelector('[data-gr-items]');
    data.items.forEach(function (it) {
      var li = el('li', 'gr-item');
      var media = el('div', 'gr-item__media');
      media.appendChild(el('span', 'gr-item__qty', String(it.quantity || 1)));
      loadImage(it.handle, media);

      var info = el('div', 'gr-item__info');
      info.appendChild(el('span', 'gr-item__name', it.title));
      if (it.variant_title && it.variant_title !== 'Default Title') {
        info.appendChild(el('span', 'gr-item__variant', it.variant_title));
      }
      // "2 × S/ 99.00": explica de dónde sale el precio de la línea
      if ((it.quantity || 1) > 1) {
        info.appendChild(el('span', 'gr-item__variant', it.quantity + ' × ' + money(it.price)));
      }

      li.appendChild(media);
      li.appendChild(info);
      li.appendChild(el('span', 'gr-item__price', money((it.price || 0) * (it.quantity || 1))));
      list.appendChild(li);
    });

    // Las líneas llegan a precio original y el total ya trae el descuento (ej. pack x2:
    // 198 → 149, EasySell lo registra como "QUANTITY DISCOUNT"). Mostramos el paso
    // intermedio para que el cliente vea por qué bajó el precio.
    var itemsSum = data.items.reduce(function (s, it) { return s + (it.price || 0) * (it.quantity || 1); }, 0);
    var shipping = data.shipping_price || 0;
    var discount = data.discount > 0 ? data.discount : itemsSum + shipping - (data.total || 0);
    discount = Math.round(discount * 100) / 100;
    var isPack = data.items.some(function (it) { return (it.quantity || 1) > 1; });

    root.querySelector('[data-gr-subtotal]').textContent = money(itemsSum || data.subtotal || data.total);
    if (discount >= 0.01) {
      root.querySelector('[data-gr-discount-label]').textContent = isPack ? 'Descuento por pack' : 'Descuento';
      root.querySelector('[data-gr-discount]').textContent = '−' + money(discount);
      root.querySelector('[data-gr-discount-wrap]').hidden = false;

      var saving = root.querySelector('[data-gr-saving]');
      saving.appendChild(document.createTextNode('¡Ahorraste '));
      saving.appendChild(el('strong', null, money(discount)));
      saving.appendChild(document.createTextNode(isPack ? ' con tu pack!' : '!'));
      root.querySelector('[data-gr-saving-wrap]').hidden = false;
    }

    var ship = root.querySelector('[data-gr-shipping]');
    if (!shipping) { ship.textContent = 'Gratis'; ship.classList.add('is-free'); }
    else ship.textContent = money(shipping);
    root.querySelector('[data-gr-total]').textContent = money(data.total);

    if (data.status_url) {
      var st = root.querySelector('[data-gr-status]');
      st.href = data.status_url;
      st.hidden = false;
    }
    root.querySelector('[data-gr-summary]').hidden = false;

    var advance = Number(root.getAttribute('data-advance') || 0);
    if (data.total > advance) {
      root.querySelector('[data-gr-balance]').textContent = money(data.total - advance);
      root.querySelector('[data-gr-balance-wrap]').hidden = false;
    }
  }

  // ---- Lima / provincia -----------------------------------------------------
  function setZone(root, zone) {
    root.querySelectorAll('[data-gr-zone-btn]').forEach(function (b) {
      var on = b.getAttribute('data-gr-zone-btn') === zone;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    root.querySelectorAll('[data-gr-zone]').forEach(function (p) {
      p.hidden = p.getAttribute('data-gr-zone') !== zone;
    });
    var note = root.querySelector('[data-gr-paynote]');
    if (note) note.textContent = root.getAttribute('data-paynote-' + zone) || note.textContent;
  }

  function initZone(root, data) {
    var code = data && data.province_code;
    var zone = !code || LIMA_CODES.indexOf(code) > -1 ? 'lima' : 'provincia';
    setZone(root, zone);
    root.querySelectorAll('[data-gr-zone-btn]').forEach(function (b) {
      b.addEventListener('click', function () { setZone(root, b.getAttribute('data-gr-zone-btn')); });
    });
  }

  // ---- Provincia: Shalom o contra entrega -----------------------------------
  // Nada preseleccionado. Al elegir, se muestra solo su paso 2 (el Yape vive
  // únicamente en el de Shalom) y se baja suavemente hasta él.
  function initMethod(root) {
    var cards = root.querySelectorAll('[data-gr-method-card]');
    var hint = root.querySelector('[data-gr-pick-hint]');
    cards.forEach(function (card) {
      var input = card.querySelector('input');
      input.addEventListener('change', function () {
        var method = card.getAttribute('data-gr-method-card');
        cards.forEach(function (c) { c.classList.toggle('is-selected', c === card); });
        var target = null;
        root.querySelectorAll('[data-gr-method]').forEach(function (p) {
          var on = p.getAttribute('data-gr-method') === method;
          p.hidden = !on;
          if (on) target = p;
        });
        if (hint) hint.hidden = true;
        if (target && target.scrollIntoView) {
          var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        }
      });
    });
  }

  // ---- WhatsApp -------------------------------------------------------------
  function paintWhatsApp(root, data) {
    var wa = root.getAttribute('data-wa');
    var number = data && data.number;
    root.querySelectorAll('[data-gr-wa]').forEach(function (a) {
      var msg = root.getAttribute('data-msg-' + a.getAttribute('data-gr-wa')) || '';
      msg = msg.replace('#[PEDIDO]', number ? '#' + number : '').replace('[PEDIDO]', number || '');
      msg = msg.replace(/\s{2,}/g, ' ').replace(/\s+\./g, '.').trim();
      a.href = 'https://wa.me/' + wa + (msg ? '?text=' + encodeURIComponent(msg) : '');
    });
  }

  // ---- Copiar número Yape ---------------------------------------------------
  function initCopy(root) {
    root.querySelectorAll('[data-gr-copy]').forEach(function (btn) {
      var label = btn.querySelector('[data-gr-copy-label]');
      var original = label ? label.textContent : '';
      btn.addEventListener('click', function () {
        var value = btn.getAttribute('data-gr-copy');
        var done = function () {
          btn.classList.add('is-copied');
          if (label) label.textContent = '¡Copiado!';
          setTimeout(function () {
            btn.classList.remove('is-copied');
            if (label) label.textContent = original;
          }, 2200);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(value).then(done, function () { fallbackCopy(value); done(); });
        } else { fallbackCopy(value); done(); }
      });
    });
  }

  function fallbackCopy(value) {
    var t = document.createElement('textarea');
    t.value = value;
    t.setAttribute('readonly', '');
    t.style.position = 'fixed';
    t.style.opacity = '0';
    document.body.appendChild(t);
    t.select();
    try { document.execCommand('copy'); } catch (e) {}
    document.body.removeChild(t);
  }

  // ---- BOOT -----------------------------------------------------------------
  function boot() {
    var root = document.querySelector('[data-gracias]');
    if (!root) return;
    var params = new URLSearchParams(window.location.search);
    var data = getData(root, params);
    if (data) {
      paintHero(root, data);
      paintSummary(root, data);
    }
    initZone(root, data);
    initMethod(root);
    paintWhatsApp(root, data);
    initCopy(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
